// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"ig","categoryName":"jg","categoryImage":"kg","categoryContent":"lg","bottomAligned":"mg"};